
import { useEffect, useState } from 'react'
import { devLevel } from '../../utilities/gameFlow'
import './gameView.css'
import Level from './level'
import { GameFlow } from '../../game/types'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { currentGameAtom, currentProgressAtom, currentSectionAtom, progressDispatchAtom } from '../state/state'



const useMusicPlayer = (src: string | undefined ) => {

    const [music, setMusic] = useState<HTMLAudioElement|null>(null);

    useEffect(() => {

        try {

        if (!src)
            return
        
        let audio = music ?? new Audio(src);

        if (audio.src !== src) {
            audio.src = src
        }

        audio.autoplay = true;
        audio.load();
        audio.play();

        setMusic(audio)
    } catch (error) {
        console.error('Error playing music', error)
    }

    return () => {
        // Pause the music on unmount
        if (music) {
            music.pause()
        }
    }

    }, [src, music])


    return music

}

const GameView =  ({currentGame: gameInPlay}: { currentGame: GameFlow}) => {

    const [currentGame, setCurrentGame] = useAtom(currentGameAtom)
    const setCurrentProgress = useSetAtom(currentProgressAtom)

    // When a game-view loads or changes -> we set the activeGame atom and reset progress
    useEffect(() => {
        setCurrentGame(gameInPlay)
        // Reset progress to start of new game
        setCurrentProgress({section: 0, frame: 0})
    }, [gameInPlay, setCurrentGame, setCurrentProgress])

    // High level game flow state
    const currentProgress = useAtomValue(currentProgressAtom)
    const dispatchCurrentProgress = useSetAtom(progressDispatchAtom)

    // Function to smoothly fade audio
    // const fadeAudio = (audio: HTMLAudioElement, fadeLevel: number, fadeTime = 1000) => {

    //     const initialVolume = audio.volume;
    //     const fadeInterval = 200;
    //     const dimin = (initialVolume / fadeTime) * fadeInterval;

    //     let fader = setInterval( () => {

    //         // Only fade if past the fade out point or not at zero already
    //         if ((audio.currentTime >= fadeLevel) && (audio.volume > 0.0)) {
    //             if (audio.volume - dimin >= 0)
    //                 audio.volume -= dimin;
    //             else 
    //                 audio.volume = 0;
    //         }
    //         // When volume at zero stop all the intervalling
    //         if (audio.volume === 0.0) {
    //             clearInterval(fader);
    //         }
    //     }, fadeInterval);
    // }


    const currnetSection = currentGame?.[currentProgress.section] ?? gameInPlay[currentProgress.section]
    const music = useMusicPlayer(currnetSection?.music)

    
    return <div>

        <Level 
            currentSection={currnetSection}
            goToNextSection={() => dispatchCurrentProgress({type: 'GO_TO_NEXT_SECTION'})}
        />

    </div>

}

export default GameView;